import React, { useState } from 'react';
import { Form, Input, Button } from 'antd';
import TitleStep from './titleFormStep';

// Step components should NOT have their own <Form />
// They only return Form.Item(s) to be rendered inside the parent <Form>
// const TitleStep = (formDataValue) => (<>

//     {console.log(formDataValue, 'formDataValue')}

//     <Form.Item
//         label="Title"
//         name="title"
//         rules={[{ required: true, message: 'Please enter a title' }]}
//     >
//         <Input onChange={(e) => formDataValue('title', e.target.value)} placeholder="Type title" />
//     </Form.Item>
// </>
// );

const EmailStep = () => (
    <Form.Item
        label="Email"
        name="email"
        rules={[{ required: true, message: 'Please enter an email' }]}
    >
        <Input placeholder="Type email" />
    </Form.Item>
);

const NameStep = () => (
    <Form.Item
        label="Name"
        name="name"
        rules={[{ required: true, message: 'Please enter your name' }]}
    >
        <Input placeholder="Type name" />
    </Form.Item>
);

const MultiFromPage = () => {
    const [form] = Form.useForm();
    const [step, setStep] = useState(0);


    const [formDataValue, setFormDataValue] = useState({
        title: '',
    });

    const handleFormDataChange = (newData) => {
        setFormDataValue(newData);
        console.log('Updated data in parent:', newData);
    };

    console.log(formDataValue.title, 'newData--ww');


    const [formData, setFormData] = useState({
        name: '',
        title: 'ssss',
        description: '',
        role: '',
        mode: '',
        agentName: '',
        personality: '',
        defaultLanguage: '',
        useCase: '',
        dynamicPrompt: '',
        dynamicPromptStatus: false,
        training: {},
        parameters: {},
        createdCode: '',
        conversationBoxTitle: '',
        themeBackgroundColor: ''
    });

    console.log(formData, 'formDataformData');





    const steps = [<TitleStep formDataValue={formDataValue} onChange={handleFormDataChange} />, <EmailStep />, <NameStep />];

    const next = async () => {
        try {
            await form.validateFields();
            setStep(step + 1);
        } catch (err) {
            console.log('Validation failed');
        }
    };

    const prev = () => setStep(step - 1);

    const submit = async () => {
        try {
            await form.validateFields();
            const values = form.getFieldsValue(); // ✅ gets all fields
            console.log('Submitted Data:', values);
        } catch (err) {
            console.log('Validation failed');
        }
    };

    return (
        <Form
            form={form}
            initialValues={formData}
            layout="vertical"
            style={{ maxWidth: 400, margin: '0 auto' }}>
            {steps[step]}

            <div style={{ marginTop: 24 }}>
                {step > 0 && <Button onClick={prev}>Previous</Button>}
                {step < steps.length - 1 && <Button type="primary" onClick={next}>Next</Button>}
                {step === steps.length - 1 && (
                    <Button type="primary" onClick={submit}>
                        Submit
                    </Button>
                )}
            </div>
        </Form>
    );
};

export default MultiFromPage;
